import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import ReportComponent from "../components/ReportComponent"; // ✅ Đúng

const reportData = [
  { transactionId: "HD209037", time: "14:28", quantity: 2, revenue: 38000, actualRevenue: 38000 },
  { transactionId: "HD209036", time: "14:17", quantity: 2, revenue: 80000, actualRevenue: 80000 },
  { transactionId: "HD209035", time: "14:16", quantity: 5, revenue: 281000, actualRevenue: 281000 },
];

const ReportPage = () => {
  const reportRef = useRef(null);
  const [zoom, setZoom] = useState(1);

  const handlePrint = useReactToPrint({
    content: () => {
      if (!reportRef.current) {
        console.error("Không tìm thấy nội dung cần in!");
        return null;
      }
      return reportRef.current;
    },
    documentTitle: "Bao_Cao_Cuoi_Ngay",
    onBeforeGetContent: () => {
      console.log("Chuẩn bị in...");
      return Promise.resolve(); // Đảm bảo nội dung load trước khi in
    },
    onAfterPrint: () => {
      console.log("In xong.");
    },
  });

  return (
    <ReportComponent
      ref={reportRef} // ✅ Đảm bảo truyền ref đúng
      handlePrint={handlePrint}
      zoom={zoom}
      setZoom={setZoom}
      reportData={reportData}
    />
  );
};

export default ReportPage;
